// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Супровід впровадження» (Implementation Assistance, ключ `imp`, група `meta`). */
export const implementationAssistanceManifest: IModuleManifest = {
  key: 'imp',
  group: 'meta',
  slug: 'implementation-assistance',
  prefix: 'IMP',
  name: { en: 'Implementation Assistance', uk: 'Супровід впровадження' },
  entities: [
    { key: 'imp', slug: 'imp', name: { en: 'Implementation Assistance', uk: 'Супровід впровадження' }, main: true },
    { key: 'implementation_milestone', slug: 'implementation-milestone', name: { en: 'Implementation Milestones', uk: 'Віхи' }, main: false },
    { key: 'implementation_training_session', slug: 'implementation-training-session', name: { en: 'Implementation Training Sessions', uk: 'Навчальні сесії' }, main: false },
    { key: 'implementation_support_request', slug: 'implementation-support-request', name: { en: 'Implementation Support Requests', uk: 'Запити на підтримку' }, main: false },
  ],
  loadState: () => import('./state/implementationAssistanceSlice').then((m) => m.implementationAssistanceSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
